import React from 'react'
import Markdown from '../../../../../Markdown'
import { checkMention } from '../../../../../../../utilities'
import useStyles from './styles'

const MAX_COMMENT_LENGHT = 300

interface ShowMoreLessProps {
  content: string
  mentionClass: string
  allUsers: Record<string, LocalUser>
  me: string
  mentionMeClass: string
}

const ShowMoreLess: React.FC<ShowMoreLessProps> = ({
  content = '',
  mentionClass,
  allUsers,
  me,
  mentionMeClass
}) => {
  const [expanded, setExpanded] = React.useState(false)

  const actualContent = React.useMemo(() => {
    const isMention = checkMention(
      content,
      mentionClass,
      allUsers,
      me,
      mentionMeClass
    )
    return isMention ? isMention : content
  }, [content, mentionClass, allUsers, me, mentionMeClass])

  const classes = useStyles()

  const toggle = React.useCallback(
    e => {
      e.preventDefault()
      e.stopPropagation()
      setExpanded(old => !old)
    },
    [setExpanded]
  )

  if (actualContent.length <= MAX_COMMENT_LENGHT)
    return <Markdown>{actualContent}</Markdown>

  return (
    <>
      <Markdown>
        {expanded
          ? actualContent
          : `${actualContent.substring(0, MAX_COMMENT_LENGHT)}...`}
      </Markdown>
      <div className={classes.action} onClick={toggle}>
        Show {expanded ? 'less' : 'more'}
      </div>
    </>
  )
}

export default ShowMoreLess
